<app-uni-page [parent]="this" pageTitle="Addon Work in Progress" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[100]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <app-ag-grid [gridOptions]="itdAddonGridOptions"></app-ag-grid>

        <ng-template #wipCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="goWipToInvoice(row)">WIP</button>
        </ng-template>

        <ng-template #viewDocCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="hasAddonDocs(row)" (click)="viewAddonDocs(row)">View Documents</button>
        </ng-template>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
  </div>
  <div class="right-buttons">
    <button  pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>